import SearchPageFilter from './searchPageFilter';

const searchPageFilterConfig = {
  name: 'SearchPageFilter',
  class: SearchPageFilter,
  querySelector: {
    controller: '.search-aggregations__control',
    target: '.search-aggregations__aggregation_items',
  },
  querySelectorAll: {
    facets: '.toggleable-filter',
  },
};

export default searchPageFilterConfig;
